import { useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { convertToTitleCase, getCSRAdminPortalPae } from "js/formatting";
import { getAdminAlerts } from "redux/slices/getAdminAlertsSlice";
import CardAlertBase from "components/General/CardAlertBase";
import EditForm from "components/CSRAdmin/Alerts/Form/EditForm";
import CancelForm from "../Form/CancelForm";
import SiteWideAlertModal from "components/CSRAdmin/ModalDialogs/SiteWideAlertModal";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import { useTranslation } from "react-i18next";

export default function ActiveAlert({ alert }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openAlertEdit, setOpenAlertEdit] = useState(false);
  const [alertEditCancel, setAlertEditCancel] = useState(false);
  const [confirmationModalEdit, setConfirmationModalEdit] = useState(false);
  const [confirmationModalCancel, setConfirmationModalCancel] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const getAlertsData = async () => {
    dispatch(getAdminAlerts());
    setConfirmationModalCancel(false);
    setConfirmationModalEdit(false);
  };

  const Actions = () => {
    return (
      <div className="mt-2">
        <button
          className="mr-2 text-sm text-ui-blue underline"
          onClick={() => setAlertEditCancel(true)}
        >
          {t("AgentCSR-Admin-ActiveAlert-button-1")}
        </button>
        <span className="text-theme-text-tertiary">/</span>
        <button
          className="ml-2 text-sm text-ui-blue underline"
          onClick={() => setOpenAlertEdit(true)}
        >
          {t("AgentCSR-Admin-ActiveAlert-button-2")}
        </button>
      </div>
    );
  };

  return (
    <>
      <CardAlertBase
        cardFields={[
          {
            title: t("AgentCSR-Admin-ActiveAlert-title-1"),
            value: convertToTitleCase(alert?.portal),
          },
          {
            title: "",
            value: "",
          },
          {
            title: t("AgentCSR-Admin-ActiveAlert-title-2"),
            value: convertToTitleCase(
              alert?.group?.toLowerCase() === "companywide"
                ? "Company Wide"
                : alert?.group
            ),
          },
          {
            title: t("AgentCSR-Admin-ActiveAlert-title-3"),
            value: convertToTitleCase(
              getCSRAdminPortalPae(alert?.userView, alert?.group)
            ),
          },
          {
            title: t("AgentCSR-Admin-ActiveAlert-title-4"),
            value: moment(alert?.startDate).format("MM/DD/YYYY"),
          },
          {
            title: t("AgentCSR-Admin-ActiveAlert-title-5"),
            value: moment(alert?.endDate).format("MM/DD/YYYY"),
          },
        ]}
      >
        <Actions />
      </CardAlertBase>

      <SiteWideAlertModal
        title={t("AgentCSR-Admin-ActiveAlert-SiteWideAlertModal-title-1")}
        description={
          <EditForm
            alert={alert}
            setDialogState={setOpenAlertEdit}
            setConfirmationModal={setConfirmationModalEdit}
            setConfirmationMessage={setConfirmationMessage}
            setOpenAlertEdit={setOpenAlertEdit}
          />
        }
        enablePrimaryButton={false}
        enableSecondaryButton={false}
        showCloseIcon={true}
        dialogState={openAlertEdit}
        setDialogState={setOpenAlertEdit}
        subTitle={t("AgentCSR-Admin-ActiveAlert-SiteWideAlertModal-subtitle-1")}
      />

      <SiteWideAlertModal
        title={t("AgentCSR-Admin-ActiveAlert-SiteWideAlertModal-title-2")}
        description={
          <CancelForm
            alert={alert}
            setDialogState={setAlertEditCancel}
            setConfirmationModal={setConfirmationModalCancel}
            setConfirmationMessage={setConfirmationMessage}
            setAlertEditCancel={setAlertEditCancel}
          />
        }
        showCloseIcon={false}
        enablePrimaryButton={false}
        enableSecondaryButton={false}
        dialogState={alertEditCancel}
        setDialogState={setAlertEditCancel}
      />

      <GeneralPurposeDialog
        title={t("AgentCSR-Admin-GeneralPurposeDialog-title")}
        desc={confirmationMessage}
        state={confirmationModalEdit}
        setState={setConfirmationModalEdit}
        showCloseButton={false}
        dialogOnClose={() => getAlertsData()}
        secondaryButtonAction={() => getAlertsData()}
      />

      <GeneralPurposeDialog
        title={t("AgentCSR-Admin-GeneralPurposeDialog-title")}
        desc={confirmationMessage}
        showCloseButton={false}
        state={confirmationModalCancel}
        setState={setConfirmationModalCancel}
        dialogOnClose={() => getAlertsData()}
        secondaryButtonAction={() => getAlertsData()}
      />
    </>
  );
}
